import React, { useState, useEffect } from 'react';
import './ShippingMethod.css';
import { MONTHS, WEEKDAYS_FULL } from '../../../constants/DateConstants';
import { NewReleasesRounded, Opacity } from '@material-ui/icons';
import { useSelector } from 'react-redux';
import { getLoader, money } from '../../../helper/Utility';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles, LinearProgress } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';


const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiCircularProgress-colorPrimary": props => ({
      color: props.color,
    }),
    // backgroundColor: 'khaki'
  },
}));

const TimePicker = (props) => {
  const { t, i18n } = useTranslation();
  const cart = useSelector(state => state.cartReducer);
  const frontConfig = useSelector(state => state.frontConfigReducer);
  const mainColor = useSelector(state => state.frontConfigReducer.color);
  const classes = useStyles({ color: frontConfig.color });
  const [selectedTime, setSelectedTime] = useState(props.time);
  const [selectedScheduleCode, setScheduleCode] = useState('');
  const [lastDate, setLastDate] = useState(props.date);
  const [lastType, setLastType] = useState(props.shippingType);
  const [loading, toggleLoader] = useState(false);
  const [timeWindowsArr, setTimeWindowsArr] = useState([]);
  const [lastDateCount, setLastDateCount] = useState(props.datePickCounter);
  const [currentOption, setCurrentOption] = useState({});
  const [morningAvailable, setMorning] = useState(false);
  const [afternoonAvailable, setAfternoon] = useState(false);
  const [eveningAvailable, setEvening] = useState(false);
  const [rootScrollBtnVisible, setRootScrollBtnVisibility] = useState({ morning: false, afternoon: false, evening: false });

  function handleScroll(e) {
    if (e.target.className && e.target.className.includes('TimeCellList') && (e.target.scrollWidth > e.target.clientWidth)) {
      if (e.target.className.includes('morning') && !rootScrollBtnVisible.morning) {
        setRootScrollBtnVisibility({ ...rootScrollBtnVisible, morning: true });
      } else if (e.target.className.includes('afternoon') && !rootScrollBtnVisible.afternoon) {
        setRootScrollBtnVisibility({ ...rootScrollBtnVisible, afternoon: true });
      } else if (e.target.className.includes('evening') && !rootScrollBtnVisible.evening) {
        setRootScrollBtnVisibility({ ...rootScrollBtnVisible, evening: true });
      }
    };
  };

  useEffect(() => {
    if (selectedTime !== "") {
      props.onTimeSelect(selectedTime);
    }
    window.addEventListener("scroll", handleScroll, true);
  }, []);

  useEffect(() => {
    if (props.date !== lastDate) {
      setSelectedTime('');
      setLastDate(props.date);
      props.resetTime('');
      showLoader();
    }
    if (props.selectedTitle !== currentOption.title) {
      setSelectedTime('');
    }
    if (props.shippingType !== lastType) {
      setLastType('');
    }

    const filtered = getFilteredTimeWindows();

    setTimeWindowsArr(filtered);
    if (filtered.length < 1) {
      // props.showNoTimeWindowError();
    } else if (props.datePickCounter !== lastDateCount) {
      props.openTimePicker();
    }
    setLastDateCount(props.datePickCounter)
  }, [props.selectedOption, props.day, props.date, props.selectedTitle, props.datePickCounter])


  return (
    <div className="TimePickerContainer">
      {
        loading ?
          <div className="TimeWindowLoader">
            <CircularProgress className={classes.root} />
          </div> : null
      }

      {timeWindowsArr.map((timeWindow, i) => {

        return (
          <TimeWindowCell key={props.date + '-' + i} selectedScheduleCode={selectedScheduleCode} timeWindow={timeWindow} selectedTime={selectedTime} onSelect={selectTime} date={props.date} />
        )
      })}
    </div>
  )


  function getFilteredTimeWindows() {
    var morning = false;
    var afternoon = false;
    var evening = false;
    if (props.selectedOption.length > 0) {
      let selectedOptionsLength = props.selectedOption.length;
      var availabilityFiltered = [];
      var twId = 1;

      for (let i = 0; i < selectedOptionsLength; i++) {
        const option = props.selectedOption[i];
        const dayFiltered = option.availabilities.filter((availability) => availability.code === props.day);
        if (dayFiltered[0]) {
          const dateFiltered = dayFiltered[0].dates.filter((currentDate) => currentDate.date === props.date);
          if (dateFiltered[0] && dateFiltered[0].date && dateFiltered[0].time_windows[0]) {
            dateFiltered[0].time_windows = dateFiltered[0].time_windows.map((timeWindow) => {
              morning = (morning === false && parseInt(timeWindow.code.substring(0, 2)) < 12) ? true : morning;
              afternoon = (afternoon === false && parseInt(timeWindow.code.substring(0, 2)) < 16 && parseInt(timeWindow.code.substring(0, 2)) >= 12) ? true : afternoon;
              evening = (evening === false && parseInt(timeWindow.code.substring(0, 2)) >= 16) ? true : evening
              let modifiedAvailability = { ...timeWindow };
              modifiedAvailability.scheduleOption = { ...option };
              modifiedAvailability.id = twId;
              twId += 1;
              availabilityFiltered.push(modifiedAvailability);
              return timeWindow
            })
          }
        }
      }
      setMorning(morning);
      setAfternoon(afternoon);
      setEvening(evening);
      return availabilityFiltered
    } else {
      setMorning(morning);
      setAfternoon(afternoon);
      setEvening(evening);
      return [];
    }
  }

  function selectTime(timeWindow) {
    setSelectedTime(timeWindow.code);
    setCurrentOption(timeWindow.scheduleOption);
    setScheduleCode(timeWindow.scheduleOption.code);
    props.onTimeSelect(timeWindow);
    props.setTitle(timeWindow.scheduleOption.title);
    props.onShippingTypeSelect(timeWindow.scheduleOption.title, timeWindow.scheduleOption);
  }

  function showLoader() {
    toggleLoader(true);
    setTimeout(() => {
      toggleLoader(false)
    }, 500);
  }
}

export default TimePicker;

const TimeWindowCell = (props) => {
  const { t, i18n } = useTranslation();
  const mainColor = useSelector(state => state.frontConfigReducer.color);
  const sameDayPremium = useSelector(state => state.frontConfigReducer.same_day_delivery_fee)
  const time_zone = useSelector(state => state.frontConfigReducer.time_zone)
  console.log("time_zone----", time_zone)

  useEffect(() => {
    console.log(props.timeWindow.is_closed);
  }, [props.selectedTime]);

  const showAvailability = () => {
    const max = props.timeWindow.delivery_capacity;
    const available = props.timeWindow.available_deliveries;
    const filled = max - available;
    const normalise = ((value) => ((value) * 100) / max);

    if (available > 0) {
      return (
        <div className="AvailabilityContainer">
          <LinearProgress style={{ minWidth: 80, marginRight: 10, height: 10, color: mainColor }} variant="determinate" value={normalise(filled)} />
          <p className={"AvailableText " + (props.selectedTime === props.timeWindow.code && props.selectedScheduleCode === props.timeWindow.scheduleOption.code ? "DatePickerTextWhite" : "DatePickerTextBlack")}>
            {`${available} ${t("available")}`}
          </p>
        </div>

      )
    } else {
      return (
        <p style={{ backgroundColor: mainColor }} className={"FullTagText"}>{`FULL`}</p>
      )
    }
  }

  const showDeliveryFee = () => {
    const today = isToday();
    const fee = props.timeWindow.scheduleOption.delivery_fee;
    let displayFee;

    if (fee !== null && props.timeWindow.available_deliveries > 0) {
      today ? displayFee = (fee + sameDayPremium) : displayFee = fee;
      const moneyFormat = money(displayFee);
      return (
        <p className={"TimeWindowText " + (props.selectedTime === props.timeWindow.code && props.selectedScheduleCode === props.timeWindow.scheduleOption.code ? "DatePickerTextWhite" : "DatePickerTextBlack")}>
          {moneyFormat}
        </p>
      );
    } else {
      return (
        <p className={"TimeWindowText " + (props.selectedTime === props.timeWindow.code && props.selectedScheduleCode === props.timeWindow.scheduleOption.code ? "DatePickerTextWhite" : "DatePickerTextBlack")}>
          -
        </p>
      )
    }
  }

  return (
    <div className="TimeCellContainer" onClick={selectTime}>
      <div
        style={{
          backgroundColor: props.selectedTime === props.timeWindow.code && props.selectedScheduleCode === props.timeWindow.scheduleOption.code ? mainColor : "#EFEFEF",
          opacity: props.timeWindow.is_closed ? 0.7 : isToday() && props.timeWindow.scheduleOption.accept_same_day_delivery === false ? 0.7 : props.timeWindow.available_deliveries > 0 ? 1.0 : 0.7,
          borderRadius: "6px 6px 0 0"
        }}
        className={"TimeWindowCell"}
      >
        <p className={"TimeWindowText " + (props.selectedTime === props.timeWindow.code && props.selectedScheduleCode === props.timeWindow.scheduleOption.code ? "DatePickerTextWhite" : "DatePickerTextBlack")}>
          {props.timeWindow.code}
        </p>
        {showAvailability()}
        {showDeliveryFee()}
      </div>
      <div>
        {
          props.timeWindow.scheduleOption.description ?
            <div className="ScheduleDescription" style={{ backgroundColor: mainColor + "40" }}>
              <p >{props.timeWindow.scheduleOption.description}</p>
            </div>
            : null
        }
      </div>
    </div>
  )

  function selectTime() {
    const currentTime = moment().tz(time_zone).add(1, 'hour'); // Add 1 hour to current time
    const [startTime] = props.timeWindow.code.split('-'); // Extract start time
    const timeWindowStart = moment.tz(`${props.date} ${startTime}`, 'YYYY-MM-DD HH:mm', time_zone);

    console.log("timeWindowStart:", timeWindowStart.format('YYYY-MM-DD HH:mm z'));
    console.log("Current Time:", currentTime.format('YYYY-MM-DD HH:mm z'));
    console.log("TimeWindowCell selectTime after ----- currentTime, currentTime.isAfter(timeWindowStart), time_zone, timeWindow ---",  currentTime, currentTime.isAfter(timeWindowStart), time_zone, props.timeWindow)
    
    // Disable selection if current time + 1 hour is after the time window start
    if (sameDayPremium && currentTime.isAfter(timeWindowStart)) {
      alert('This time slot is no longer available.');
      return;
    }


     if (props.timeWindow.is_closed) {
      // do nothing and escape the if statement
    } else if (isToday() && props.timeWindow.scheduleOption.accept_same_day_delivery === false) {
      // do nothing and escape the if statement
    } else if (props.timeWindow.available_deliveries > 0) {
      props.onSelect(props.timeWindow)
    }
  }

  function isToday() {
    let dateToday = new Date();
    const startDate = new Date();
    const calculatedDate = startDate.getDate();                                       // if the date is let's say 31 this line makes it 32 which may seem wrong,
    const newDateObj = new Date(startDate.getFullYear(), startDate.getMonth(), calculatedDate);    // however when we create a new date object with the value 32, it automatically fixes the date to be the 1st of next month
    const newMonth = newDateObj.getMonth();
    const newMonthText = (newMonth + 1 < 10) ? '0' + (newMonth + 1).toString() : (newMonth + 1).toString();
    const newDay = newDateObj.getDay();
    const newYear = newDateObj.getFullYear();
    const newDate = newDateObj.getDate();
    const newDateText = (newDate < 10) ? '0' + (newDate).toString() : (newDate).toString();
    const apiDate = `${newYear}-${newMonthText}-${newDateText}`;
    return (apiDate === props.date);
  }
}